<div class="detail-info">
  <div class="detail-header">
    <legend class="h3 mb-16px">{{ title }}</legend>
    <ng-content select="button"></ng-content>
  </div>

  <div class="detail-body">
    <ng-content></ng-content>
  </div>
</div>
